import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Nav_Interface } from 'src/app/Interface/Nav_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { LoginService } from 'src/app/Service/Login/Login.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-Login',
  templateUrl: './Login.component.html',
  styleUrls: ['./Login.component.scss']
})
export class LoginComponent implements OnInit {

  Token: string = ""
  password: string = "";
  username: string = "";
  LoadingLogin: boolean = false
  MustChangePassword: boolean = false
  BaserUrlImage:string=environment.BaseUrl
  CapchaImage:string=''
  CapchaCode:string=''
  CapchaHash:string=''

  MainBackground:number=0

  Double_loging_Check: number = 0
  TokenStationTimer: any;

  constructor(
    private Alertify_Service: AlertifyService,
    private loginService: LoginService,
    public router: Router
  ) { }

  ngOnInit() {
    this.MainBackground = this.randomIntFromInterval(1, 6)


  }


  randomIntFromInterval(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min)
  }


  Time_Token_Station() {
    this.Double_loging_Check = 30
    this.TokenStationTimer = setInterval(() => {
      if (this.Double_loging_Check <= 0) {
        this.LoadingLogin = false
        clearInterval(this.TokenStationTimer);
      }
      else {
        this.Double_loging_Check = this.Double_loging_Check - 1
      }

    }, 1000);
  }


  ReadData_Loging_KeySearch_Timer: any
  ReadData_Loging_KeySearch() {

    if (this.ReadData_Loging_KeySearch_Timer) {
      clearTimeout(this.ReadData_Loging_KeySearch_Timer);
      this.ReadData_Loging_KeySearch_Timer = null;
    }

    this.ReadData_Loging_KeySearch_Timer = setTimeout(function () {
      this.LogingFunctionReload()
    }.bind(this), 1000);

  }

  LogingFunctionReload() {
    location.reload();
  }



  public getBrowserName() {
    const agent = window.navigator.userAgent.toLowerCase()
    switch (true) {
      case agent.indexOf('edge') > -1:
        return 'edge';
      case agent.indexOf('opr') > -1 && !!(<any>window).opr:
        return 'opera';
      case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
        return 'chrome';
      case agent.indexOf('trident') > -1:
        return 'ie';
      case agent.indexOf('firefox') > -1:
        return 'firefox';
      case agent.indexOf('safari') > -1:
        return 'safari';
      default:
        return 'other';
    }
  }


  RestCapcha():void{
    this.LoadingLogin = true
    this.loginService.RestCapcha(this.CapchaImage).subscribe(
      response=>{
        this.LoadingLogin = false
        this.CapchaImage=response['imageName']
        this.CapchaHash=response['code']
        //this.Alertify_Service.SuccessMessage("The security code was refreshed")
      }
    )
  }


  LogingFunction(): void {

    if (this.username == "" || this.password == "") {
      this.Alertify_Service.ErrorMessage("Please enter your username and password")
    }
    else if(!this.CapchaCode && this.CapchaHash)
    {
      this.Alertify_Service.ErrorMessage("Please enter the security code")
    }
    else {
      this.LoadingLogin = true
      this.loginService.Login_Action(this.username, this.password,this.CapchaHash,this.CapchaCode, this.getBrowserName()).subscribe(
        response => {

          if (!response['token']) {
            this.LoadingLogin = false
            this.CapchaImage=response['imageName']
            this.CapchaHash=response['code']
            this.Alertify_Service.ErrorMessage("The username or password is incorrect")
          }
          else if (response['token'] == '-2') {
            this.RestCapcha()
            this.Alertify_Service.ErrorMessage("The security code is incorrect")
          }
          else if (response['token'] == '-1') {
            this.CapchaImage=''
            this.Time_Token_Station()
            this.Alertify_Service.ErrorMessage("This account is already signed in and currently active.")
          }
          else if (response['mustChangePassword'] == true) {
            this.CapchaImage=''
            this.Token = response['token']
            localStorage.setItem('Daro_User_UserImage', response['userImage']);
            localStorage.setItem('Daro_User_Fullname', response['fullname']);

            var Menu: Array<Nav_Interface> = response['menu_user']
            localStorage.setItem('Daro_User_Nav', JSON.stringify(Menu));

            this.MustChangePassword = true
          }
          else {

            this.Alertify_Service.SuccessMessage("Welcome, " + response['fullname'])
            localStorage.setItem('Daro_User_Token', response['token']);
            localStorage.setItem('Daro_User_UserImage', response['userImage']);
            localStorage.setItem('Daro_User_Fullname', response['fullname']);
            localStorage.setItem('Daro_User_Type', response['type']);
            localStorage.setItem('Daro_User_TokenStation', "500");
            localStorage.setItem('Daro_User_CanLetterHistory', response['canLetterHistory']);

            var Menu: Array<Nav_Interface> = response['menu_user']
            localStorage.setItem('Daro_User_Nav', JSON.stringify(Menu));

            this.router.navigate(['/Dashboard']);
            this.ReadData_Loging_KeySearch()
          }

        }
      )
    }






  }

}
